export const questions = [
  { 
    id: 0, 
    text: "Align the bars with your chin and widow's peak", 
    type: "horizontal-alignment" 
  },
  { 
    id: 1, 
    text: "Align the bars with the left and right sides of your face, around the cheekbones area", 
    type: "vertical-alignment" 
  },
  { 
    id: 2, 
    text: "Is your jaw more square, rounded, or in between?", 
    type: "jaw-shape" 
  },
  { 
    id: 3, 
    text: "Are any of these parts of your face wider than the rest?", 
    type: "multiple-choice", 
    options: ["Forehead", "Cheekbones", "Jaw", "All are close in size"] 
  }
];
